export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14561.363a6744.jpg";